import { Icon } from "@iconify/react";
import Card from "../common/Card";
import LoadingSpinner from "../common/LoadingSpinner";

const WordPressActionsCard = ({
  availableActions,
  isLoadingActions,
  connectionError,
  onGoToWebsiteConnections,
}) => {
  return (
    <Card
      title={
        <div className="flex items-center gap-4">
          <Icon icon="mdi:wordpress" className="text-4xl text-[#21759b]" />
          <div>
            <h2 className="text-xl font-semibold">WordPress Integration</h2>
            <p className="text-sm text-text-secondary">
              Manage WordPress connections and perform actions on your connected
              sites
            </p>
          </div>
        </div>
      }
      className="mb-6"
    >
      <div className="space-y-4">
        <div className="p-4 bg-info/10 border border-info/20 rounded-lg">
          <p className="text-sm text-text-secondary">
            <strong>Note:</strong> To add a new WordPress connection, go to the{" "}
            <button
              onClick={onGoToWebsiteConnections}
              className="text-primary hover:underline font-medium"
            >
              Website Connections
            </button>{" "}
            page and select "WordPress" as the platform.
          </p>
        </div>

        {isLoadingActions ? (
          <div className="p-4 bg-bg-light rounded-lg flex items-center justify-center gap-3">
            <LoadingSpinner size="sm" />
            <span className="text-sm text-text-secondary">
              Loading available actions...
            </span>
          </div>
        ) : availableActions.length > 0 ? (
          <div className="p-4 bg-bg-light rounded-lg">
            <h3 className="font-semibold mb-2">Available Actions</h3>
            <div className="flex flex-wrap gap-2">
              {availableActions.map((action, index) => (
                <span
                  key={index}
                  className="px-3 py-1 bg-primary/10 text-primary rounded-full text-xs font-medium"
                >
                  {action}
                </span>
              ))}
            </div>
          </div>
        ) : null}

        {connectionError && (
          <div className="p-3 bg-danger/10 border border-danger/20 rounded-lg text-sm text-danger">
            {connectionError}
          </div>
        )}
      </div>
    </Card>
  );
};

export default WordPressActionsCard;
